import { render, staticRenderFns } from "./HMISetting.vue?vue&type=template&id=dccacbaa&"
import script from "./HMISetting.vue?vue&type=script&lang=js&"
export * from "./HMISetting.vue?vue&type=script&lang=js&"
import style0 from "./HMISetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VCard,VChip,VChipGroup,VFileInput})
